module.exports = __webpack_public_path__ + "static/img/room1.0148443.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hotel/room1.jpg
// module id = 4MJZ
// module chunks = 0